import { useMutation } from "@apollo/client";

import { SettingsResearchTypeEditRoute_UpdateVisitSummaryTemplateDocument } from "../mutations.generated";

export default function useSettingsResearchTypeEditRoute_UpdateVisitSummaryTemplate() {
    const [mutate, { loading, error }] = useMutation(SettingsResearchTypeEditRoute_UpdateVisitSummaryTemplateDocument);

    const updateVisitSummaryTemplate = (researchTypeId: string, template: unknown) =>
        mutate({ variables: { input: { researchTypeId, template } } });

    return {
        updateVisitSummaryTemplate,
        loading,
        error,
    };
}
